const getUpgradeUruguayPlansDictionary = function (data) {
  const uruguayUpgradePlansDictionary = {
    trademo_intel_uy_pro: {
      name: "Trademo intel uruguay Pro",
      key: "trademo_intel_uy_pro",
      upgradeMessageArrivalDate: "You have access last 12 months of trade data. To access complete data. ",
      upgradeMessageEmailAlert: "You do not have sufficient credits available to set Email Alert. To set more alerts ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access last 12 months of trade data. To access complete data. ",
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: ["Last 12 months shipments data (updated daily)", "Unlimited searches per day", "120,000 shipment downloads per user annually"],
    },
    trademo_intel_uy_advanced: {
      name: "Trademo intel uruguay Advanced",
      key: "trademo_intel_uy_advanced",
      upgradeMessageArrivalDate: "You have access last 24 months of trade data. To access complete data.",
      upgradeMessageEmailAlert: "You do not have sufficient credits available to set Email Alert. To set more alerts ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access last 24 months of trade data. To access complete data.",
      dashboardUpgradeMessageEmailAlert: "Never miss out on tracking important shipments.",
      planFeatures: [
        "Latest Shipments data (updated monthly)",
        "Colombia Imports & Exports(Jan 2015 - till date)",
        "Argentina Imports (Jan 2019 - till date)",
        "Peru Imports (Jan 2019 - till date)",
        "Ecuador Imports & Exports(Jan 2019 - till date)",
        "Panama Imports & Exports(Jan 2019 - till date)",
        "Brazil Imports & Exports(Jan 2021 - till date)",
        "300,000 shipments downloads annually per user, per country",
      ],
    },
    trademo_intel_uy_enterprise: {
      name: "Trademo intel uruguay enterprise",
      key: "trademo_intel_uy_enterprise",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent  Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You do not have sufficient credits available to set Email Alert. To set more alerts ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent  Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: ["Jan 2011 - Present shipments data (updated daily)", "Unlimited downloads per user"],
    },
  };
  return uruguayUpgradePlansDictionary;
};
exports.getUpgradeUruguayPlansDictionary = getUpgradeUruguayPlansDictionary;
